/* R24 · OpenAI Ads Measurement-Pixel (ChatGPT-Anzeigen) — Shop-Teil.
 * Doku: docs/tracking/OPENAI-ADS.md · Vertrag: scripts/openai-pixel.contract.test.mjs
 *
 * - Laedt oaiq.min.js ERST nach Marketing-Einwilligung (Shopify Customer Privacy API). Ohne Einwilligung:
 *   kein Skript, kein Cookie, keine Anfrage. Widerruf → oaiq('consent', false) (loescht __oppref/__obref).
 * - Laeuft bewusst im Shop und nicht in der Pixel-Sandbox: nur hier sieht das SDK die Landing-URL
 *   (Klick-Kennung oppref) und kann eigene Cookies setzen. Den Kauf misst das Custom Pixel im Admin.
 * - Ereignisse: page_viewed (jede Seite), contents_viewed (Produktseite), items_added (jede erfolgreiche
 *   Antwort von /cart/add, egal welcher Knopf), checkout_started (Klick auf „Zur Kasse").
 * - Mit Einwilligung stehen obref (immer), oppref (nur nach ChatGPT-Anzeige; zusaetzlich der ERSTE als
 *   _r24_oai_oppref_first), erste/letzte Kampagnen-Beruehrung (_r24_att_first/_r24_att_last, JSON) und die
 *   aeltere Kurzform _r24_utm als versteckte Warenkorb-Attribute an der Bestellung — fuer die Server-Meldung
 *   (Conversions API, NUR nach Zahlung) und die eigene Zuordnung im Portal. Widerruf entfernt alles.
 * - Leistungen (Aufbauservice, Menge = cm) zaehlen als 1 Stueck zum Zeilenwert.
 * - Nie E-Mail/Name/Adresse aus dem Shop. Betraege in Cent (ISO-4217-Nebeneinheit), wie OpenAI verlangt. */
(function () {
  'use strict';
  var tag = document.currentScript || document.querySelector('script[data-oai-pixel]');
  if (!tag || window.__r24oai) return;
  window.__r24oai = 1;
  var PIXEL = tag.getAttribute('data-oai-pixel');
  var CUR = tag.getAttribute('data-oai-currency') || 'EUR';
  var SDK = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  var state = 'pending'; // pending | granted | denied

  function warn(what, e) { if (typeof console !== 'undefined') console.warn('[R24] OpenAI-Pixel ' + what + ': ' + ((e && e.message) || e)); }
  function cents(v) { var n = Math.round(Number(v)); return isFinite(n) && n >= 0 ? n : null; }

  // Abrufregel (CLAUDE.md): wortgleiche Kopie von r24Fetch — nie throw, JSON nur bei JSON-Body, Zeitlimit, console.warn.
  function r24Fetch(url, init, retry, ms){
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0, o = {}, k;
    for (k in (init || {})) o[k] = init[k];
    if (ctl){ o.signal = ctl.signal; tm = setTimeout(function(){ ctl.abort(); }, ms || 20000); }
    return fetch(url, o).then(function(r){
      return r.text().then(function(t){
        clearTimeout(tm);
        var d = null, s = r.status, wait;
        if (/^\s*[\[{]/.test(t || '')){ try { d = JSON.parse(t); } catch (e) { d = null; } }
        if (s === 429 && retry){
          wait = Math.min(4, Math.max(1, parseFloat(r.headers && r.headers.get('Retry-After')) || 1.5));
          return new Promise(function(go){ setTimeout(go, wait * 1000); }).then(function(){ return r24Fetch(url, init, false, ms); });
        }
        return { ok: r.ok, status: s, data: d, text: t || '', url: r.url || '',
          kind: r.ok ? (d ? 'ok' : 'empty') : s === 429 ? 'rate' : s >= 500 ? 'server' : 'client' };
      });
    }).then(null, function(e){
      clearTimeout(tm);
      var to = !!(e && e.name === 'AbortError');
      if (typeof console !== 'undefined') console.warn('[R24] ' + url + ': ' + (to ? 'Zeitlimit' : (e && e.message) || e));
      return { ok: false, status: 0, data: null, text: '', url: '', kind: to ? 'timeout' : 'network' };
    });
  }

  /* ------------------------------------------------------------ Einwilligung -- */
  function marketingOk() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.marketingAllowed !== 'function') return false;
    try { return cp.marketingAllowed() === true; } catch (e) { return false; } // fail closed
  }

  function measure(name, data, opts) {
    if (state !== 'granted' || typeof window.oaiq !== 'function') return;
    try { window.oaiq('measure', name, data, opts || {}); } catch (e) { warn(name, e); }
  }

  function grant() {
    if (state === 'granted') return;
    var first = !window.oaiq;
    state = 'granted';
    if (first) {
      // Offizieller Lader von OpenAI (Warteschlange bis das SDK da ist), nur ausgeschrieben.
      var q = function () { q.q.push(arguments); };
      q.q = [];
      window.oaiq = q;
      var js = document.createElement('script');
      js.async = true;
      js.src = SDK;
      js.onerror = function () { warn('Laden', SDK); };
      document.head.appendChild(js);
      window.oaiq('init', { pixelId: PIXEL });
    }
    window.oaiq('consent', true);
    if (first) pageEvents();
    setTimeout(keepRef, 1500); // SDK muss die Cookies erst schreiben
  }

  function deny() {
    if (state === 'granted' && typeof window.oaiq === 'function') {
      try { window.oaiq('consent', false); } catch (e) { warn('Widerruf', e); }
      dropRef();
    }
    state = 'denied';
  }

  /* -------------------------------------------------------------- Ereignisse -- */
  function pageEvents() {
    measure('page_viewed', { type: 'contents' });
    var pid = tag.getAttribute('data-oai-product-id');
    var price = cents(tag.getAttribute('data-oai-product-price'));
    if (pid) {
      var item = { id: pid, name: tag.getAttribute('data-oai-product-name') || '', content_type: 'product', quantity: 1 };
      var data = { type: 'contents', contents: [item] };
      if (price !== null) { item.amount = price; item.currency = CUR; data.amount = price; data.currency = CUR; }
      measure('contents_viewed', data);
    }
  }

  /* Angefragte Menge je Variante aus dem Request (JSON {id,quantity} / {items:[…]}, FormData, URL-Form).
   * /cart/add.js antwortet mit der GANZEN Warenkorbzeile (Menge + Zeilensumme NACH dem Hinzufuegen) —
   * lag der Artikel schon im Korb, war items_added vorher zu hoch (27.09.2026: +1 gelegt, 2 gemeldet). */
  function requestedQty(body) {
    var map = {}, add = function (id, q) {
      if (id == null || id === '') return;
      var n = parseInt(q, 10); map[String(id)] = (map[String(id)] || 0) + (n > 0 ? n : 1);
    };
    try {
      if (typeof body === 'string') {
        if (/^\s*\{/.test(body)) {
          var j = JSON.parse(body);
          if (Array.isArray(j.items)) j.items.forEach(function (i) { add(i && (i.id || i.variant_id), i && i.quantity); });
          else add(j.id || j.variant_id, j.quantity);
        } else if (typeof URLSearchParams === 'function') {
          var u = new URLSearchParams(body); add(u.get('id'), u.get('quantity'));
        }
      } else if (body && typeof body.get === 'function') { // FormData / URLSearchParams
        add(body.get('id'), body.get('quantity'));
      }
    } catch (e) { warn('Menge', e); }
    return map;
  }

  /* Leistungen mit Abrechnungs-Menge (Aufbauservice: Menge = Zentimeter, 05.10.2026: „quantity 439“).
   * Fuer OpenAI ist das EINE Leistung: Menge 1, Betrag = Zeilenwert. Erkennung am Handle bzw. an den
   * Zeilen-Eigenschaften, die nur Service-Zeilen tragen (_r24_cm / _r24_k / _r24_solo). */
  function isService(l) {
    var p = (l && l.properties) || {};
    return /^aufbauservice/.test(String((l && l.handle) || '')) || !!(p._r24_cm || p._r24_k || p._r24_solo);
  }

  // /cart/add.js antwortet mit einer Zeile ODER {items:[…]} — beides wird zu einem items_added.
  function itemsAdded(d, req) {
    var list = d && (Array.isArray(d.items) ? d.items : d.variant_id ? [d] : null);
    if (!list || !list.length) return;
    req = req || {};
    var total = 0, contents = [];
    list.forEach(function (l) {
      var vid = String(l.variant_id || l.id);
      var unit = cents(l.final_price != null ? l.final_price : l.price);
      var qty = req[vid] || 1; // hinzugefuegte Menge, nie die Zeilenmenge
      if (isService(l)) { if (unit !== null) unit = unit * qty; qty = 1; } // Leistung = 1 Stueck zum Zeilenwert
      if (unit !== null) total += unit * qty;
      var it = { id: vid, name: l.product_title || l.title || '', content_type: 'product', quantity: qty };
      if (unit !== null) { it.amount = unit; it.currency = CUR; }
      contents.push(it);
    });
    measure('items_added', { type: 'contents', amount: total, currency: CUR, contents: contents });
    if (!added) { added = 1; keepRef(true); } // Warenkorb existiert jetzt sicher: Kennungen einmal je Seite anhaengen
  }
  var added = 0;

  // Alle Warenkorb-Wege des Themes (Produktseite, Set-Konfigurator, Planer, Merkliste …) laufen ueber fetch.
  // Nur beobachten: die Original-Antwort geht unveraendert zurueck, gelesen wird eine Kopie.
  if (typeof window.fetch === 'function') {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          var req = requestedQty(init && init.body);
          p.then(function (r) {
            if (!r || !r.ok || state !== 'granted') return;
            r.clone().text().then(function (t) {
              if (!/^\s*\{/.test(t || '')) return;
              try { itemsAdded(JSON.parse(t), req); } catch (e) { warn('items_added', e); }
            }, function (e) { warn('items_added', e); });
          }, function () {});
        }
      } catch (e) { warn('fetch', e); }
      return p;
    };
  }

  function isCheckout(el) {
    if (!el || !el.closest) return false;
    var b = el.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"]');
    return !!b;
  }
  document.addEventListener('click', function (e) {
    if (isCheckout(e.target)) measure('checkout_started', { type: 'contents' });
  }, true);

  /* -------------------------- Klick-Kennung an die Bestellung (fuer Server) -- */
  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  /* Letzte Kampagnen-Beruehrung (utm_* + Einstiegspfad), 30 Tage im Geraet — nur mit Einwilligung, nie
   * personenbezogen. Ueberlebt Planer → Warenkorb → Kasse und den Rueckkehr-Besuch ohne UTM (05.10.2026). */
  var UTM_DAYS = 30;
  function utmTouch() {
    var now = Date.now(), cur = null, keep = null;
    try {
      var u = new URLSearchParams(location.search), s = u.get('utm_source');
      if (s) cur = [s, u.get('utm_medium'), u.get('utm_campaign'), u.get('utm_content'), u.get('utm_term')]
        .map(function (v) { return String(v || '').replace(/\|/g, '/').slice(0, 80); }).join('|')
        + '|' + location.pathname.slice(0, 80) + '|' + new Date(now).toISOString().slice(0, 10);
    } catch (e) { cur = null; }
    try {
      if (cur) localStorage.setItem('r24_utm', JSON.stringify({ v: cur, t: now }));
      var j = JSON.parse(localStorage.getItem('r24_utm') || 'null');
      keep = j && j.v && now - j.t < UTM_DAYS * 864e5 ? j.v : null;
    } catch (e) { keep = cur; }
    return keep || '';
  }

  /* Kennungen an die Bestellung (versteckte Warenkorb-Attribute → Webhook → Conversions API):
   * - _r24_oai_obref: Browser-Kennung des OpenAI-Pixels — offizielle Empfehlung fuer Pixel + Server
   *   („read the __obref cookie … include it unchanged as user.obref“). Nur mit Einwilligung; sie ist zugleich
   *   der Einwilligungs-Nachweis fuer den Server (ohne obref sendet er keine Nutzerdaten).
   * - _r24_oai_oppref: Klick-Kennung, nur bei Besuchern aus einer ChatGPT-Anzeige.
   * - _r24_utm: letzte Kampagnen-Beruehrung (source|medium|campaign|content|term|pfad|datum). */
  /* Erste und letzte Kampagnen-Beruehrung (24.10.2026) — JSON ohne Personendaten, 30 Tage im Geraet, nur mit
   * Einwilligung. Beruehrung = Seite mit utm_source ODER oppref ODER fremdem Verweis (Suchmaschine, chatgpt.com).
   * oppref selbst steht nur als „o:1“ darin; der Wert geht separat (_r24_oai_oppref / _r24_oai_oppref_first).
   * Feldnamen kurz (Attribut-Laenge): t Zeit, s/m/c/a/g = utm_source/medium/campaign/content/term, p Pfad, r Verweis-Host. */
  function touchNow() {
    try {
      var u = new URLSearchParams(location.search), s = u.get('utm_source') || '', o = u.get('oppref') ? 1 : 0, r = '';
      var m = /^https?:\/\/([^\/?#]+)/i.exec(document.referrer || '');
      if (m && m[1].replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) r = m[1].toLowerCase().replace(/^www\./, '');
      if (!s && !o && !r) return null;
      var c = function (v) { return String(v || '').slice(0, 80); };
      return { t: new Date().toISOString(), s: c(s), m: c(u.get('utm_medium')), c: c(u.get('utm_campaign')), a: c(u.get('utm_content')),
        g: c(u.get('utm_term')), p: location.pathname.slice(0, 120), r: r.slice(0, 80), o: o };
    } catch (e) { return null; }
  }
  function touches() {
    var now = Date.now(), cur = touchNow(), first = null, last = null;
    var ok = function (j) { return j && j.t && now - Date.parse(j.t) < UTM_DAYS * 864e5 ? j : null; };
    try {
      first = ok(JSON.parse(localStorage.getItem('r24_att_first') || 'null'));
      last = ok(JSON.parse(localStorage.getItem('r24_att_last') || 'null'));
      if (cur) {
        if (!first) { first = cur; localStorage.setItem('r24_att_first', JSON.stringify(cur)); }
        last = cur; localStorage.setItem('r24_att_last', JSON.stringify(cur));
      }
    } catch (e) { first = first || cur; last = cur || last; }
    return { first: first, last: last };
  }
  function firstOppref(opp) {
    try {
      var f = localStorage.getItem('r24_oai_opp1');
      if (!f && opp) { localStorage.setItem('r24_oai_opp1', opp); f = opp; }
      return f || '';
    } catch (e) { return opp || ''; }
  }

  function keepRef(force) {
    if (state !== 'granted') return;
    var opp = cookie('__oppref'), obr = cookie('__obref'), utm = utmTouch(), tt = touches(), opp1 = firstOppref(opp);
    if (!opp && !obr && !utm && !tt.last) return;
    var attrs = { _r24_oai_obref: obr, _r24_utm: utm };
    if (opp) attrs._r24_oai_oppref = opp; // nie mit leer ueberschreiben, solange der Klick gilt
    if (opp1) attrs._r24_oai_oppref_first = opp1;
    if (tt.first) attrs._r24_att_first = JSON.stringify(tt.first);
    if (tt.last) attrs._r24_att_last = JSON.stringify(tt.last);
    var key = opp + '|' + obr + '|' + utm + '|' + (attrs._r24_att_first || '') + '|' + (attrs._r24_att_last || ''), seen = '';
    try { seen = sessionStorage.getItem('r24_oai_ref') || ''; } catch (e) { seen = ''; }
    if (seen === key && !force) return;
    r24Fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }, false, 8000).then(function (res) {
      if (!res.ok) return;
      try { sessionStorage.setItem('r24_oai_ref', key); } catch (e) { /* ohne Speicher: naechste Seite erneut */ }
    });
  }
  // Widerruf: Kennungen vom Warenkorb nehmen (leer = Shopify entfernt das Attribut) — dann sendet auch der Server nichts.
  function dropRef() {
    try {
      sessionStorage.removeItem('r24_oai_ref');
      ['r24_utm', 'r24_att_first', 'r24_att_last', 'r24_oai_opp1'].forEach(function (k) { localStorage.removeItem(k); });
    } catch (e) { /* egal */ }
    r24Fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _r24_oai_obref: '', _r24_oai_oppref: '', _r24_utm: '', _r24_oai_oppref_first: '', _r24_att_first: '', _r24_att_last: '' } })
    }, false, 8000);
  }

  /* ----------------------------------------------------------------- Start -- */
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e && e.detail;
    var ok = d && typeof d.marketingAllowed === 'boolean' ? d.marketingAllowed : marketingOk();
    if (ok) grant(); else deny();
  });
  if (marketingOk()) {
    grant();
  } else {
    var S = window.Shopify;
    if (S && typeof S.loadFeatures === 'function' && !S.customerPrivacy) {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && marketingOk()) grant();
        });
      } catch (e) { warn('Einwilligung', e); }
    }
  }
})();
